import { useState } from 'react'
import { AlertTitle, Alert } from '@mui/material'
import { useIntl } from '@/intl'

export function WarningCard() {
  const texts = useTexts()

  return (
    <Alert severity="warning">
      <AlertTitle>{texts.title}</AlertTitle>
      {texts.description}
    </Alert>
  )
}

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'deleteOrderModal.warningCard.title' }),
    description: translate({ id: 'deleteOrderModal.warningCard.description' }),
  }))

  return api
}
